require('../../modules/es6.math.log1p');
module.exports = require('../../modules/_core').Math.log1p;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/log1p.js
// module id = 1423
// module chunks = 2